import React, {useCallback, useState} from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";

import {AutocompleteInput, BooleanInput, ReferenceInput, required, Title,} from "react-admin";

import {NotifyForm, schoolYears, showErrorNotify, TreeCheckboxInput,} from "../../components";
import env from "../../env";
import {downloadFilePost} from "../../components/FileDownload";

const BcDanhSachHS = (props) => {
    const [changeSchoolYear, setChangeSchoolYear] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [unitIds, setUnitIds] = useState([]);
    const [schoolYearId, setSchoolYearId] = useState(schoolYears[0].id);
    const [loading, setLoading] = useState(false);
    const getReportUrl = useCallback(
        (type, fullDay, allStudent) => {
            return downloadFilePost(
                `${env.reportURL}/reports/danhSachHocSinh`,
                "danh_sach_HS.xlsx",
                {
                    fullDayOnly: fullDay,
                    allStudent,
                    schoolYearId,
                    showCard,
                    unitIds,
                }
            );
        },
        [schoolYearId, showCard, unitIds]
    );

    const billBatchTemplateAllClazzes = useCallback(() => {
        if (!unitIds || unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách lớp");
            return;
        }
        setLoading(true)
        getReportUrl("XLS", false, true)
            .catch(() => {
                showErrorNotify("Tải báo cáo thất bại");
            })
            .finally(() => setLoading(false));
    }, [unitIds, getReportUrl]);

    const fullDayOnly = useCallback(() => {
        if (!unitIds || unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách lớp");
            return;
        }
        setLoading(true)
        getReportUrl("XLS", true, false)
            .catch(() => {
                showErrorNotify("Tải báo cáo thất bại");
            })
            .finally(() => setLoading(false));
    }, [unitIds, getReportUrl]);

    const notFullDayOnly = useCallback(() => {
        if (!unitIds || unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách lớp");
            return;
        }
        setLoading(true)
        getReportUrl("XLS", false, false)
            .catch(() => {
                showErrorNotify("Tải báo cáo thất bại");
            })
            .finally(() => setLoading(false));
    }, [unitIds, getReportUrl]);

    const validate = useCallback(
        (values) => {
            if (changeSchoolYear) {
                setUnitIds([]);
                setChangeSchoolYear(false);
            } else {
                setUnitIds(values.unitIds);
            }
            return {};
        },
        [changeSchoolYear]
    );

    const onSchoolYearChanged = useCallback((e, value) => {
        setSchoolYearId(value);
        setChangeSchoolYear(true);
    }, []);

    const onChangeShowCard = useCallback((e, value) => {
        setShowCard(value);
    }, []);

    return (
        <Card>
            <Title title="resources.bcDanhSachHS.name"/>
            <CardContent>
                <NotifyForm
                    isLoading={loading}
                    params={{changeSchoolYear, showCard, unitIds, schoolYearId}}
                    validate={validate}
                    allClazzes={billBatchTemplateAllClazzes}
                    fullDayClazzes={fullDayOnly}
                    notFullDayClazzes={notFullDayOnly}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <ReferenceInput
                                source="schoolYearId"
                                reference="schoolYears"
                                label="resources.schoolYears.name"
                                perPage={50}
                                validate={required()}
                                onChange={onSchoolYearChanged}
                                {...props}
                            >
                                <AutocompleteInput source="name"/>
                            </ReferenceInput>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <label>Danh sách lớp *</label>
                            <div style={{maxHeight: 300, overflow: "auto"}}>
                                <ReferenceInput
                                    source="unitIds"
                                    reference="units"
                                    perPage={999}
                                    filter={{
                                        clazzWithParents: true,
                                        schoolYear: schoolYearId,
                                    }}
                                    {...props}
                                >
                                    <TreeCheckboxInput
                                        optionValue="id"
                                        optionText="name"
                                        expandTopLevel
                                        schoolYear={schoolYearId}
                                    />
                                </ReferenceInput>
                            </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <BooleanInput
                                label="resources.bcDanhSachHS.showCard"
                                source="showCard"
                                onChange={onChangeShowCard}
                                {...props}
                            />
                        </Grid>
                    </Grid>
                </NotifyForm>
            </CardContent>
        </Card>
    );
};

export default BcDanhSachHS;
